import { render, staticRenderFns } from "./CribPlan.vue?vue&type=template&id=0b247f23&scoped=true"
import script from "./CribPlan.vue?vue&type=script&lang=ts"
export * from "./CribPlan.vue?vue&type=script&lang=ts"
import style0 from "./CribPlan.vue?vue&type=style&index=0&id=0b247f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b247f23",
  null
  
)

export default component.exports